module.exports = __webpack_public_path__ + "img/chatbot-2.b9f77cf9.svg";